import { FC } from "react";

interface FooterProps {
  onClose?: () => void;
  colorClass?:string;
}

const Footer: FC<FooterProps> = ({ onClose,colorClass }) => {
  return (
    <div className={`${colorClass??'bg-nivabupa-blue-dark'} text-white relative`}>
      {onClose && (
        <button className="absolute right-0 pt-4 pr-4" onClick={onClose}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            viewBox="0 0 16 16"
            className="h-4 w-4"
          >
            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z" />
          </svg>
        </button>
      )}
      <div
        className="grid gap-8 px-16 pt-8"
        style={{
          gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
        }}
      >
        <div>
          <ul className="text-sm">
            <li className="text-base font-bold underline">Health Insurance</li>
            <li>
              <a
                href="/content/nivabupa/in/en/home/health-insurance-plans.html"
                rel="noopener noreferrer dofollow"
                target="_self"
              >
                Health Insurance Plans
              </a>
            </li>
            <li>
              <a
                href="/content/nivabupa/in/en/home/individual-health-insurance-plans.html"
                rel="noopener noreferrer dofollow"
                target="_self"
              >
                Individual Health Insurance Plans
              </a>
            </li>
            <li>
              <a
                href="/content/nivabupa/in/en/home/family-health-insurance-plans.html"
                rel="noopener noreferrer dofollow"
                target="_self"
              >
                Family Health Insurance Plans
              </a>
            </li>
            <li>
              <a
                href="/content/nivabupa/in/en/home/critical-illness-insurance.html"
                rel="noopener noreferrer dofollow"
                target="_self"
              >
                Critical Illness Insurance Plans
              </a>
            </li>
            <li>
              <a
                href="/content/nivabupa/in/en/home/family-health-insurance-plans.html"
                rel="noopener noreferrer dofollow"
                target="_self"
              >
                Personal Accident Insurance Plans
              </a>
            </li>
          </ul>
        </div>
        <div>
          <ul className="text-sm">
            <li className="text-base font-bold underline">About Niva Bupa</li>
            <li>
              <a
                href="https://www.nivabupa.com/about-us/aboutuspages/index.aspx"
                rel="noopener noreferrer dofollow"
                target="_blank"
              >
                About Us
              </a>
            </li>
            <li>
              <a
                href="https://transaction.nivabupa.com/customer-care/health-services/contact-us.aspx"
                rel="noopener noreferrer dofollow"
                target="_blank"
              >
                Contact Us
              </a>
            </li>
            <li>
              <a
                href="https://transaction.nivabupa.com/about-us/aboutuspages/Unclaimed-Amount.aspx"
                rel="noopener noreferrer dofollow"
                target="_blank"
              >
                Unclaimed Amount
              </a>
            </li>

            <li>
              <a
                href="https://transaction.nivabupa.com/media-center/health-insurance/index.aspx"
                rel="noopener noreferrer dofollow"
                target="_blank"
              >
                Media Center
              </a>
            </li>

            <li>
              <a
                href="https://transaction.nivabupa.com/about-us/aboutuspages/financialreports.aspx"
                rel="noopener noreferrer dofollow"
                target="_blank"
              >
                Public Disclosures
              </a>
            </li>

            <li>
              <a
                href="https://www.bupa.com/"
                rel="noopener noreferrer nofollow"
                target="_blank"
              >
                Bupa
              </a>
            </li>

            <li>
              <a
                href="https://truenorth.co.in/"
                rel="noopener noreferrer nofollow"
                target="_blank"
              >
                True North
              </a>
            </li>
          </ul>
        </div>
        <div>
          <ul className="text-sm">
            <li className="text-base font-bold underline">Tools for You</li>
            <li>
              <a
                href="/content/nivabupa/in/en/home/health-insurance-articles.html"
                rel="noopener noreferrer dofollow"
                target="_self"
              >
                Health Insurance Articles
              </a>
            </li>
            <li>
              <a
                href="https://transaction.nivabupa.com/sales/dst/index.aspx"
                rel="noopener noreferrer dofollow"
                target="_blank"
              >
                Channel Payment
              </a>
            </li>
            <li>
              <a
                href="https://transaction.nivabupa.com/health-articles/articles/health-insurance-terms.aspx"
                rel="noopener noreferrer dofollow"
                target="_blank"
              >
                Glossary
              </a>
            </li>
            <li>
              <a
                href="https://Grievance.Vendor@nivabupa.com"
                rel="noopener noreferrer dofollow"
                target="_blank"
              >
                Supplier Grievance Redressal
              </a>
            </li>

            <li>
              <a
                href="https://transaction.nivabupa.com/customer-care/health-services/grievance-redressal.aspx"
                rel="noopener noreferrer dofollow"
                target="_blank"
              >
                Customer Grievance Redressal
              </a>
            </li>

            <li>
              <a
                href="https://transaction.nivabupa.com/about-us/aboutuspages/careers.aspx"
                rel="noopener noreferrer dofollow"
                target="_blank"
              >
                Careers
              </a>
            </li>
          </ul>
        </div>
        <div>
          <ul className="text-sm">
            <li className="text-base font-bold underline">Legal</li>
            <li>
              <a
                href="https://transaction.nivabupa.com/customer-care/health-services/exclusions.aspx"
                rel="noopener noreferrer dofollow"
                target="_blank"
              >
                Exclusions
              </a>
            </li>
            <li>
              <a
                href="http://www.policyholder.gov.in/"
                rel="noopener noreferrer dofollow"
                target="_blank"
              >
                IRDA Consumer Education
              </a>
            </li>
            <li>
              <a
                href="https://transaction.nivabupa.com/customer-care/health-services/Stewardship-Code.aspx"
                rel="noopener noreferrer dofollow"
                target="_blank"
              >
                Stewardship Policy
              </a>
            </li>

            <li>
              <a
                href="/content/nivabupa/in/en/home/help-centre/help-terms-and-condition.html"
                rel="noopener noreferrer dofollow"
                target="_self"
              >
                Website Terms &amp; Conditions
              </a>
            </li>

            <li>
              <a
                href="/content/nivabupa/in/en/home/help-centre/privacypolicy.html"
                rel="noopener noreferrer dofollow"
                target="_self"
              >
                Privacy Policy
              </a>
            </li>

            <li>Insurance Ombudsman</li>
          </ul>
        </div>
        <div>
          <ul className="text-sm">
            <li className="text-base font-bold underline">Log In</li>
            <li>
              <a
                href="https://transaction.nivabupa.com/customer-care/health-services/health-care-providers.aspx"
                rel="noopener noreferrer dofollow"
                target="_"
              >
                Service Provider
              </a>
            </li>

            <li>
              <a
                href="https://spectrum.nivabupa.com/spectrum/login.aspx"
                rel="noopener noreferrer dofollow"
                target="_"
              >
                Agents
              </a>
            </li>

            <li>
              <a
                href="https://healthlink.nivabupa.com/HLCL/UI/Logon/ClientPortalLogin.aspx"
                rel="noopener noreferrer dofollow"
                target="_"
              >
                Health Link Portal
              </a>
            </li>
          </ul>
        </div>
        <div>
          <ul className="flex flex-col gap-4">
            <li className="text-base font-bold underline">Follow Us</li>
            <li>
              <a
                href="https://www.facebook.com/NivaBupa"
                rel="noopener noreferrer dofollow"
                target="_"
                title="Facebook"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5"
                  fill="currentColor"
                  viewBox="0 0 16 16"
                >
                  <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951z" />
                </svg>
              </a>
            </li>
            <li>
              <a
                href="https://twitter.com/Niva_Bupa"
                rel="noopener noreferrer dofollow"
                target="_"
                title="Twitter"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 16 16"
                  className="h-5 w-5"
                >
                  <path d="M5.026 15c6.038 0 9.341-5.003 9.341-9.334 0-.14 0-.282-.006-.422A6.685 6.685 0 0 0 16 3.542a6.658 6.658 0 0 1-1.889.518 3.301 3.301 0 0 0 1.447-1.817 6.533 6.533 0 0 1-2.087.793A3.286 3.286 0 0 0 7.875 6.03a9.325 9.325 0 0 1-6.767-3.429 3.289 3.289 0 0 0 1.018 4.382A3.323 3.323 0 0 1 .64 6.575v.045a3.288 3.288 0 0 0 2.632 3.218 3.203 3.203 0 0 1-.865.115 3.23 3.23 0 0 1-.614-.057 3.283 3.283 0 0 0 3.067 2.277A6.588 6.588 0 0 1 .78 13.58a6.32 6.32 0 0 1-.78-.045A9.344 9.344 0 0 0 5.026 15z" />
                </svg>
              </a>
            </li>
            <li>
              <a
                href="https://www.linkedin.com/company/niva-bupa/"
                rel="noopener noreferrer dofollow"
                target="_"
                title="LinkedIn"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 16 16"
                  className="h-5 w-5"
                >
                  <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854V1.146zm4.943 12.248V6.169H2.542v7.225h2.401zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016a5.54 5.54 0 0 1 .016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225h2.4z" />
                </svg>
              </a>
            </li>
            <li>
              <a
                href="https://www.youtube.com/c/nivabupa"
                rel="noopener noreferrer dofollow"
                target="_"
                title="YouTube"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 16 16"
                  className="h-5 w-5"
                >
                  <path d="M8.051 1.999h.089c.822.003 4.987.033 6.11.335a2.01 2.01 0 0 1 1.415 1.42c.101.38.172.883.22 1.402l.01.104.022.26.008.104c.065.914.073 1.77.074 1.957v.075c-.001.194-.01 1.108-.082 2.06l-.008.105-.009.104c-.05.572-.124 1.14-.235 1.558a2.007 2.007 0 0 1-1.415 1.42c-1.16.312-5.569.334-6.18.335h-.142c-.309 0-1.587-.006-2.927-.052l-.17-.006-.087-.004-.171-.007-.171-.007c-1.11-.049-2.167-.128-2.654-.26a2.007 2.007 0 0 1-1.415-1.419c-.111-.417-.185-.986-.235-1.558L.09 9.82l-.008-.104A31.4 31.4 0 0 1 0 7.68v-.123c.002-.215.01-.958.064-1.778l.007-.103.003-.052.008-.104.022-.26.01-.104c.048-.519.119-1.023.22-1.402a2.007 2.007 0 0 1 1.415-1.42c.487-.13 1.544-.21 2.654-.26l.17-.007.172-.006.086-.003.171-.007A99.788 99.788 0 0 1 7.858 2h.193zM6.4 5.209v4.818l4.157-2.408L6.4 5.209z" />
                </svg>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <hr className="w-full my-8 bg-neutral-100 opacity-100 dark:opacity-50" />
      <div className="flex flex-col gap-2.5 px-16 pb-8 text-xs">
        <p>
          Insurance is a subject matter of solicitation. **Niva Bupa Health
          Insurance Company Limited (formerly known as Max Bupa Health Insurance
          Company Limited) (IRDAI Registration Number 145, Category:Health),
          ‘Max’, ‘Max Logo’, ‘Bupa’ and ‘HEARTBEAT’ logo are registered
          trademarks of their respective owners and are being used
          by&nbsp;**Niva Bupa Health Insurance Company Limited (formerly known
          as Max Bupa Health Insurance Company Limited) under license.
          Registered office:- 3rd Floor, Capital Cyberscape, Sector 59. Gurgaon, Customer
          Helpline: 1860-500-8888. Fax: +91 11 41743397. Website:
          www.nivabupa.com. CIN: L66000DL2008PLC182918.
        </p>
        <p>
          <sup>1</sup>Niva Bupa processes pre-authorisation requests within 30
          minutes for all active policies, subject to receiving all documents
          and information(s) up to Niva Bupa’s satisfaction. The above
          commitment does not include pre-authorisation settlement at the time
          of discharge or system outage.
        </p>
        <p>
          <sup>2</sup>Since Inception refers to claim data from 2010 till
          December 2023
        </p>
        <p>
          First time premium shown is calculated on base sum insured (Rs 5 lacs
          for Health Companion, Heartbeat, Health Premia, Health Pulse and
          GoActiveTM, Rs 10.5 lacs for Money Saver and Rs 10 lacs for Health
          Assurance) of an individual aged 25 residing in Delhi NCR region. The
          premium changes as per the product features selected and the insured
          details you submit on the website.
        </p>
        <p>*Price rise applies only to the product ReAssure</p>
        <p>
          Disease calculator based on Super Tertiary Treatment cost in Delhi NCR
          for defined condition. Claim cost range for the selected disease is as
          per the claims paid by Niva Bupa for the period 2016 to 2019.
        </p>
        <p>
          Estimated claim cost over 10 years is computed after considering the
          medical inflation calculated in Willis Towers Watson
          surveyhttps://asiainsurancepost.com/health/indian-health-care-benefit-costs-expected-rise-11-2019willis-towers-watson-survey-finds.&nbsp;
        </p>
        <p>
          Base premium is calculated for Health Companion for an individual aged
          25, residing in Delhi NCR. The premium amount is illustrative only and
          it may vary over the period depending on the type of product, features
          / addons selected, changes to product version, inflation rates and
          underwriting decision of the company.&nbsp;
        </p>
        <p>
          Niva Bupa processes pre-auth requests within 30 minutes for all active
          policies, subject to receiving all documents and information(s) up to
          Niva Bupa’s satisfaction. The above commitment does not include
          pre-authorization settlement at the time of discharge or system
          outage. For more details on terms and conditions, exclusions and
          waiting period, please read sales brochure before concluding a sale.
        </p>
        <p>BEWARE OF SPURIOUS / FRAUD PHONE CALLS!</p>
        <p>
          IRDAI is not involved in activities like selling insurance policies,
          announcing bonus or investment or premium. Public receiving such phone
          calls are requested to lodge a police complaint.
        </p>
        <p>
          Beware of misleading telephone calls from people posing as Niva Bupa
          officials, agents, Officials from ECI (Office of the Executive Council
          of Insurers) etc. and offering alluring benefits or sharing false
          information on your policy or on Niva Bupa.
        </p>
        <p>
          Niva Bupa shall not be responsible for any loss or damages whatsoever
          for any acts or omissions arising out of such spurious calls and all
          customers are advised to contact our customer care at 1860-500-8888
          and verify any representations or promises made by any such spurious
          callers before acting upon the same.
        </p>
        <p>
          <i className="text-base">
            **The name of the Company has been changed from Max Bupa Health
            Insurance Company Limited to Niva Bupa Health Insurance Company
            Limited effective 5th July, 2021
          </i>
        </p>
      </div>
    </div>
  );
};

export default Footer;
